module.exports = __webpack_public_path__ + "img/24_11.e6931e74.png";